module.exports = __webpack_public_path__ + "img/677f8752d650900449303e797199c55e.jpg";